import * as React from "react"
import { Toast } from "./"
import { ToastContext } from "./context"
import { useToastActions } from "./hooks"
import * as styles from "./styles.css"

export const ToastConsumer = ToastContext.Consumer

export interface ToastProviderProps {
  children: React.ReactNode
  closeButtonLabel?: string
}

export function ToastProvider({ children }: ToastProviderProps) {
  const { toasts, showToast, removeToast } = useToastActions()

  const contextValue = React.useMemo(() => {
    return {
      showToast,
    }
  }, [showToast])

  return (
    <ToastContext.Provider value={contextValue}>
      {children}

      <div className={styles.container}>
        {toasts.map((toast, index) => (
          <Toast
            key={`toast-${index}`} // this is probably not the best, but we can't use symbol as key :(
            message={toast.message}
            onClose={() => removeToast(toast.id)}
          />
        ))}
      </div>
    </ToastContext.Provider>
  )
}
